import React from 'react'
import { Heading } from '../../util/typography'
import IndicationsList from './IndicationsList'

const Indications = ({ indicationId }) => {
    return (
        <>
            {/* <section>
                <header>
                    <Heading.H4 as='h2'>For KEYTRUDA (pembrolizumab)</Heading.H4>
                </header>
                <div>
                    <IndicationsList columns={2} indicationId={indicationId} />
                </div>
            </section> */}
            <section>
                {/* <header>
                    <Heading.H4 as='h2'>For KEYTRUDA Qlex (pembrolizumab and berahyaluronidase alfa-xxxx)</Heading.H4>
                </header> */}
                <div>
                    <IndicationsList indicationId={indicationId} />
                </div>
            </section>

        </>
    )
}

export default Indications;
